import { createFileRoute, Outlet } from '@tanstack/react-router';

import { CustomPartDetailsLayout } from '@/areas/parts/PartDetailsPage/CustomPartDetailsLayout';
import type { PageStaticData } from '@/shared/routing';

// Keeps the side panel and its unsaved edits across tabs, which declare their own access.
export const Route = createFileRoute('/_authenticated/parts/custom/details/$customPartSpecificationId')({
    staticData: { access: 'authenticated', chrome: 'none' } satisfies PageStaticData,
    component: RouteComponent,
    // The panel's state belongs to one custom part; the router would keep it across a param change.
    remountDeps: ({ params }) => params.customPartSpecificationId,
});

function RouteComponent(): JSX.Element {
    const { customPartSpecificationId } = Route.useParams();
    return (
        <CustomPartDetailsLayout customPartSpecificationId={customPartSpecificationId}>
            <Outlet />
        </CustomPartDetailsLayout>
    );
}
